import SelectWithFetch from './SelectWithFetch';
import getClientDocumentTypes from '../../api/clients/getClientDocumentTypes';

const SelectClientDocumentType = (props) => {
  return <SelectWithFetch fetch={getClientDocumentTypes} {...props} placeholder="ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°" />;
};

export default SelectClientDocumentType;
